import React, {Fragment} from 'react';

import withClass from '../../../hoc/withClass';
import NavigationItems from './NavigationItems/NavigationItems';

const leftMenu = () => (
    <Fragment>
        <NavigationItems />
    </Fragment>
);

export default withClass(leftMenu, 'site-menubar site-menubar-dark');